import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { PopoverController } from '@ionic/angular/standalone';
import { RowAction } from './row-actions';

/** The "⋯" menu's contents: a short list in a popover; picking one dismisses with that action. */
@Component({
  selector: 'admin-row-menu',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ul role="menu">
      @for (a of actions; track a.label; let i = $index) {
        @if (a.danger && (i === 0 || !actions[i - 1].danger)) {
          <li class="divider" role="separator"></li>
        }
        <li role="none">
          <button type="button" role="menuitem" [class.danger]="a.danger" (click)="pick(a)">
            @if (a.icon) {
              <span class="material-symbols-outlined" aria-hidden="true">{{ a.icon }}</span>
            }
            {{ a.label }}
          </button>
        </li>
      }
    </ul>
  `,
  styles: [
    `
      ul {
        margin: 0;
        padding: 6px;
        list-style: none;
      }
      button {
        display: flex;
        align-items: center;
        gap: 10px;
        width: 100%;
        padding: 9px 10px;
        border: 0;
        border-radius: 0.6rem;
        background: transparent;
        color: var(--cnt-ink, #222);
        font: inherit;
        font-size: 0.875rem;
        font-weight: 600;
        text-align: left;
        cursor: pointer;
      }
      button:hover,
      button:focus-visible {
        background: var(--cnt-cream, #f7f5ec);
        outline: none;
      }
      button .material-symbols-outlined {
        font-size: 18px;
        color: var(--cnt-muted, #707070);
      }
      button.danger,
      button.danger .material-symbols-outlined {
        color: var(--cnt-danger, #b3261e);
      }
      .divider {
        height: 1px;
        margin: 4px 6px;
        background: var(--cnt-line, rgba(34, 34, 34, 0.08));
      }
    `,
  ],
})
export class AdminRowMenuComponent {
  private readonly popover = inject(PopoverController);
  @Input() actions: RowAction[] = [];

  pick(action: RowAction): void {
    void this.popover.dismiss(action, 'select');
  }
}
